export default {
  // ========================= Color =========================
  'c-color-primary': '#FF850E',
  'c-color-page-white': '#ffffff',
  'c-color-page-gray': '#f8f8f8',

  // ========================= Gap =========================
  // 页面左右留白
  'c-gap-page': '32rpx',
  'c-gap-panel': '12rpx',

  // ========================= Zindex =========================
  'c-zindex-header': 9,
  'c-zindex-nav': 999,
  'c-zindex-fixed-bottom': 999,
  'c-zindex-dialog': 99999,
  'c-zindex-progress-page': 999999
}
